<template>
 <v-dialog
  style="border-radius: 10px;"
  v-model="dialog"
  width="1200"
>
  <v-card v-if="dialog"  class="px-2 py-3">
    <v-card-title class="pa-1">
      <span class="font-weight-bold headline wrld_subtitle--text">
        {{ transportRef }} - {{ $t('transport_request.update_cargo') }}
      </span>
    </v-card-title>
    <v-card-text class="pa-1">
      <v-simple-table
        :fixed-header="true"
        :height="300"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">{{ $t('general.reference') }}</th>
              <th class="text-left">{{ $t('general.type') }}</th>
              <th class="text-left">{{ $t('orders.dims') }}</th>
              <th class="text-left">{{ $t('orders.weight') }}</th>
              <th class="text-left">{{ $t('orders.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="unit in transportUnits" :key="unit.id">
              <td>{{ unit.ref }}</td>
              <td>{{ $t('packages_type.' + unit.type) }}</td>
              <td>{{ unit.dimensions | dimensionValue }}</td>
              <td>{{ (unit.weight/1000).toFixed(0) }}kg</td>
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="red" v-on="on" @click="handleRemove(unit.id, unit.newCreated)">
                      <v-icon small>fas fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('transport_request.remove_unit') }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-btn small class="ma-2" tile outlined color="kazan" @click="handleOpenNew">
        <v-icon left>fas fa-plus</v-icon> {{ $t('buttons.add_new') }}
      </v-btn>
      <v-row v-show="newUnitOpen">
        <v-col cols="12" sm="4" md="2">
          <v-text-field
            v-model="newUnit.ref"
            :label="$t('general.reference')"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-select
            v-model="newUnit.type"
            :items="unitTypes"
            label="Unit type"
            outlined
          ></v-select>
        </v-col>

        <v-col cols="12" sm="4" md="2">
          <v-text-field
            v-model="newUnit.dimensions.length"
            :label="$t('orders.length')"
            outlined
            suffix="cm"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4" md="2">
          <v-text-field
            v-model="newUnit.dimensions.width"
            :label="$t('orders.width')"
            outlined
            suffix="cm"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4" md="2">
          <v-text-field
            v-model="newUnit.dimensions.height"
            :label="$t('orders.height')"
            outlined
            suffix="cm"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4" md="1">
          <v-text-field
            v-model="newUnit.weight"
            :label="$t('orders.weight')"
            outlined
            suffix="kg"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4" md="1">
          <v-btn 
            width="70" class="ma-1" x-small outlined color="green"
            @click="handleAcceptNew"
          >
            {{ $t('buttons.add') }}
          </v-btn>
          <v-btn 
            width="70" class="ma-1" x-small outlined color="red"
            @click="handleCancelNew"
          >
            {{ $t('buttons.cancel') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="wrld-background elevation-1" @click="handleCancel"> <span color="wrld_subtitle--text">{{$t('buttons.cancel')}}</span> </v-btn>
      <v-btn v-if="!isLoading" color="accent elevation-1" class="ml-5 mr-4"  @click="handleUpdate">
        {{ $t('buttons.save') }}
        </v-btn>
      <v-btn v-else color="accent elevation-1" class="ml-5 mr-4" disabled>
        <v-progress-circular
          size="20"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import { uuid } from 'vue-uuid'
import { Required } from '@/plugins/form-validations.js'
import { locationService } from '@/_services'
import { mapActions } from 'vuex'
import TransportFormAddress from '@/components/transportRequests/new/TransportFormAddress.vue'
import moment from 'moment-timezone'

export default {
  name: 'EditUnits',
  components: {
    TransportFormAddress
  },
  props: {
    openMenu: { type: Boolean, default: false },
    editableTransport: { type: Object, default: () => null },
  },
  data () {
    return {
      Required,
      dialog: false,
      isLoading: false,
      // transport: null,
      newUnitOpen: false,
      newUnit: {
        id: '',
        ref: '',
        newCreated: true,
        type: 'CustomBox',
        weight: 0,
        dimensions: {
          width: 0,
          length: 0,
          height: 0
        }
      },
      transportUnits: null,
      transportRef: '',
      transportId: '',
      removed: [],
      added: [],
      unitTypes: [
        {value: 'CustomBox', text: this.$i18n.t('packages_type.CustomBox')},
        {value: 'CustomPallet', text: this.$i18n.t('packages_type.CustomPallet')}
      ]
    }
  },
  mounted () {
    if (this.editableTransport !== null && this.editableTransport.units !== undefined) {
      this.transportUnits = [...this.editableTransport.units]
      this.transportId = this.editableTransport.id
      this.transportRef = this.editableTransport.ref
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar',
      updateUnitsInTransport: 'updateUnitsInTransport',
    }),
    handleUpdate () {
      this.isLoading = true
      this.updateUnitsInTransport({ transportID: this.transportId, added: this.added, removed: this.removed, units: this.transportUnits, oldVal: this.editableTransport.units })
      this.$emit('units-updated')
      this.$nextTick(() => {
        this.removed = [],
        this.added = [],
        this.dialog = false
        this.isLoading = false
      })
    },
    handleCancel () {
      this.dialog = false
      this.transportUnits = [...this.editableTransport.units]
      this.removed = [],
      this.added = []
    },
    handleRemove(unitID, isNew){
      this.transportUnits = this.transportUnits.filter(function( obj ) {
          return obj.id !== unitID;
      })
      if (!!isNew) {
        this.added = this.added.filter(function( obj ) {
          return obj.id !== unitID;
        })
      } else {
        this.removed.push(unitID)
      }
    },
    handleOpenNew(){
      this.newUnitOpen = true
      this.newUnit = {
        id: uuid.v4(),
        ref: '',
        newCreated: true,
        type: 'CustomBox',
        weight: 0,
        dimensions: {
          width: 0,
          length: 0,
          height: 0
        }
      }
    },
    handleCancelNew(){
      this.newUnitOpen = false
    },
    handleAcceptNew(){
      this.newUnit.weight = this.newUnit.weight * 1000
      this.transportUnits.push(this.newUnit)
      this.added.push(this.newUnit)
      this.newUnitOpen = false
    },
  },
  computed: {},
  watch: {
    openMenu: {
      handler: function (val, oldVal) {
        this.dialog = val
      }
    },
    dialog: {
      handler: function (val, oldVal) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    editableTransport: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val !== null && this.editableTransport.units !== undefined ) {
          this.transportUnits = [...this.editableTransport.units]
          this.transportId = this.editableTransport.id
          this.transportRef = this.editableTransport.ref
        } else {
          this.transportUnits = null
        }
      }
    }
  },
  beforeDestroy () {
    this.$emit('close')
  }
}
</script>

<style lang="scss" scoped>
.lock-button {
  pointer-events: auto;
}
</style>
